import { Box, useTheme } from "@outschool/backpack";
import React from "react";
import { useLocation } from "react-router";

import { useStickyHeader } from "../../hooks/useStickyHeader";

const MOBILE_STICKY_HEADER_EXCLUDED_PATHS = ["/membership/subscribe/"];

const StickyHeaderConatiner = React.forwardRef<
  HTMLDivElement,
  { children: React.ReactNode }
>(({ children }, ref) => {
  const theme = useTheme();
  const { enabled } = useStickyHeader();
  const location = useLocation();
  const isMobileStickyHeaderExcludedPath =
    MOBILE_STICKY_HEADER_EXCLUDED_PATHS.some(path =>
      location.pathname.includes(path),
    );

  const headerContainerStyle = enabled
    ? {
        position: "sticky",
        top: 0,
        zIndex: 202,
        // improve rendering performance in Safari
        transform: "translateZ(0)",
        willChange: "transform",
        backfaceVisibility: "hidden",
        ...(isMobileStickyHeaderExcludedPath && {
          [theme.breakpoints.down("md")]: {
            position: "relative",
            top: "unset",
          },
        }),
      }
    : {};

  return (
    <Box ref={ref} sx={headerContainerStyle}>
      {children}
    </Box>
  );
});

export default StickyHeaderConatiner;
